














import translations from '@/requests/staticTranslationsQuery'

export default {
  name: 'CNodata',
  data() {
    return {
      translations
    }
  }
}
